import http from '@/utils/http';
const base_path = '/tool/wechatMiniGame/jrtt';

/**
 * 获取微信小游戏列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export function getWechatMiniGameApi(params) {
  return http.get({
    url: base_path,
    params,
  });
}

/**
 * 同步微信小游戏列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export function pullWechatMiniGameApi(params) {
  return http.get({
    url: `${base_path}/pull`,
    params,
  });
}
